<script>
	export let url
	export let alt
	export let size
</script>

<img src={url} {alt} class="max-w-full" class:md:max-w-3xl={size === 'TEXT'} />
